<template>
  <router-link v-if="to" :to="to" :class="{'c-button-white -arrow':true,'-medium -modal':medium}" :name="name">
    <span class="label">
      <span v-if="learningStatusDetail"><span class="iconFlag"></span><slot></slot></span>
      <span v-else class="label__text"><slot></slot></span>
    </span>
  </router-link>
  <a v-else :class="{'c-button-white -arrow':true,'-medium -modal':medium, '-width-fixed -right': right}" @click="emit('click')" :name="name">
    <span class="label">
      <slot></slot>
    </span>
  </a>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      to?: string | Location;
      medium?: boolean;
      right?: boolean;
      learningStatusDetail?: boolean;
      name?: string;
    }>(),
    {
      medium: false,
      right: false,
      learningStatusDetail: false,
      name: '',
    }
  );
  const emit = defineEmits<{
    (e: 'click'): void
  }>()
</script>